var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$parent.$parent.rerender)?_c('div',{staticClass:"row myrow content-mb-42"},[_c('router-link',{staticClass:"stl-link-blue stl-fw-bold_",staticStyle:{"text-decoration":"underline"},attrs:{"to":{
      name: 'ProjectEdit',
      params: {
        id: _vm.$parent.project.PROJECT_TYPE_LOAN.ID
      }
    }}},[_vm._v("\n    "+_vm._s(_vm.$parent.project.PROJECT_TYPE_LOAN.UF_NUMBER)+" -\n    "+_vm._s(_vm.$parent.project.PROJECT_TYPE_LOAN.UF_NAME)+"\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }